import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Livello_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 18 18",
	style: { enableBackground: "new 0 0 18 18" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{fill:#FFFFFF;}\n"
	}), /* @__PURE__ */ _jsx("g", {
		id: "Mask_1_",
		children: /* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M7.8,11.8c-0.5,0.3-0.9,0.2-0.9-0.4V6.6c0-0.8,0.5-0.8,1-0.5l3.8,2.3C12,8.6,12,8.7,12,8.9 c0,0.2,0,0.3-0.3,0.5L7.8,11.8z M0,8.9c0,5.7,3.7,9,9,9c5.3,0,9-3.3,9-9c0-5.2-3.7-8.9-9-9C3.7,0,0,3.7,0,8.9z"
		})
	})]
});
export default SvgPlayIcon;
